<template>
  <section class="">
    <v-card flat class="pa-0 ma-0">
      <v-card-text>
        <v-form ref="complincmanual" v-model="valid" lazy-validation>
          <v-row class="ms-1 me-1 my-0">
            <v-col cols="12" sm="4" md="4">
              <v-switch
                v-model="otherDetails.allow_sms_notification_to_sender"
                :label="` Sms alerts to Sender`"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-switch
                v-model="otherDetails.allow_sms_notification_to_receiver"
                :label="`Sms alerts to Benaficiary `"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-switch
                v-model="otherDetails.allow_pre_fund"
                :label="`is this a pre-funding parter?`"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-switch
                v-model="otherDetails.is_enable_approval_password"
                :label="`Approval Password`"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-switch
                v-model="otherDetails.is_enable_maker_checker"
                :label="`Checker/maker`"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="4" md="4">
            <v-switch
              v-model="otherDetails.enable_live_rates"
              :label="`Enable Live Rates`"
            ></v-switch>
          </v-col>
          </v-row>

          <v-row class="ms-1 me-1 my-0">
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0">
                Send Alerts if Balance less than below
              </label>
              <v-text-field
                v-model="otherDetails.alert_min_balance"
                dense
                outlined
                class="rounded"
                :rules="balance"
                placeholder="Send Alerts if Balance less than below"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0">
                Branch Limit To Make Payment
              </label>
              <v-text-field
                v-model="otherDetails.branch_limit"
                dense
                outlined
                class="rounded"
                :rules="barnchlimit"
                placeholder="Branch Limit To Make Payment"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-toolbar flat dense>
            <v-toolbar-title class="subtitle-2">
              Bank Information</v-toolbar-title
            >
          </v-toolbar>
          <v-row class="ms-1 me-1 my-0" justify="center">
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0"> Bank Name </label>
              <v-text-field
                v-model="otherDetails.bank_name"
                dense
                outlined
                class="rounded"
                :rules="banknameRules"
                placeholder=" Bank Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0"> Bank Routing Number </label>
              <v-text-field
                v-model="otherDetails.bank_routing_number"
                dense
                outlined
                class="rounded"
                :rules="bankroutingRules"
                placeholder=" Bank Routing Number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0"> Bank Account No </label>
              <v-text-field
                v-model="otherDetails.bank_account_number"
                dense
                outlined
                class="rounded"
                :rules="accountNumberRules"
                placeholder=" Bank Account No"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <span v-if="this.getCompanyDetails && this.getCompanyDetails.created_by">
        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Created By :{{
              this.getCompanyDetails && this.getCompanyDetails.created_by
                ? this.getCompanyDetails.created_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Created Date :{{
              this.getCompanyDetails && this.getCompanyDetails.created_date
                ? this.getCompanyDetails.created_date
                : null
            }}</v-col
          >
        </v-row>
        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Updated By :{{
              this.getCompanyDetails && this.getCompanyDetails.modified_by
                ? this.getCompanyDetails.modified_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Updated Date :{{
              this.getCompanyDetails && this.getCompanyDetails.modified_date
                ? this.getCompanyDetails.modified_date
                : null
            }}</v-col
          >
        </v-row>

        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Approved By :{{
              this.getCompanyDetails && this.getCompanyDetails.approved_by
                ? this.getCompanyDetails.approved_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Approved Date :{{
              this.getCompanyDetails && this.getCompanyDetails.approved_date
                ? this.getCompanyDetails.approved_date
                : null
            }}</v-col
          >
        </v-row>
      </span>
      <v-divider class="mb-0 pa-0"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed  color="primary" small @click="submitPartnerOtherInfo">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import partnerService from "@/services/partnerService/partnerService.js";
import { Partnervalidations } from "@/utils/validation";
export default {
  mixins: [alerts],
  data() {
    return {
      valid: true,
      ...Partnervalidations,
      otherDetails: {
        allow_sms_notification_to_sender: true,
        allow_sms_notification_to_receiver: true,
        allow_pre_fund: true,
        is_enable_approval_password: true,
        is_enable_maker_checker: true,
        enable_live_rates: true,
        alert_min_balance: 0,
        branch_limit: 0,
        bank_name: "",
        bank_routing_number: "",
        bank_account_number: " ",
      },
    };
  },
  props: {
    getCompanyDetails: {
      type: Object,
    },
  },
  mounted() {
    if (this.getCompanyDetails.partner_id) {
      this.getPartnerInfo();
      this.$refs.complincmanual.reset()
    }
  },
  methods: {
    async submitPartnerOtherInfo() {
      const routerDataItem = this.$route.query.partner_id;
      if (routerDataItem) {
        const validate = this.$refs.complincmanual.validate();
        if (validate) {
          try {
            const response = await partnerService.addPartnerOtherInfo(
              this.otherDetails,
              routerDataItem
            );
            if (response.status === 200) {
              this.showAlertSuccess(
                "update Other Info Data: " + response.data.message
              );
              this.getPartnerInfo();
            } else {
              this.showAlertError("Failed:" + response.data.message);
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    async getPartnerInfo() {
      const routerDataItem = this.$route.query.partner_id;
      if (routerDataItem) {
        try {
          const responseData = await partnerService.getPartnerOtherInfo(
            routerDataItem
          );
          if (responseData.status === 200) {
            this.otherDetails = responseData.data.data[0];
            console.log(this.otherDetails, "partner info data");
          } else {
            this.showAlertError("Failed:" + responseData.data.message);
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
